// https://dev.wix.com/docs/wix-cli/command-reference/introduction
export const LEARN_MORE_LINK = 'https://wix.to/pWrlyiP';
